<template>
  <component :is="tag" v-if="blok" class="facility-review">
    <figure>
      <SvgIcon name="func_quote" class="icon" />
      <blockquote>
        <p v-if="blok.quote" class="size-m">{{ blok.quote }}</p>
      </blockquote>
      <p v-if="blok.date" class="date size-2xs">
        {{ useFormattedDate(blok.date) }}
      </p>
      <figcaption>
        <span
          v-if="
            blok.author_name && blok.author_age > 0 && blok.author_label_age
          "
          class="author bold size-2xs"
          >{{ blok.author_name }}, {{ blok.author_age }}
          {{ blok.author_label_age }}</span
        >
        <span v-else-if="blok.author_name" class="author bold size-2xs">{{
          blok.author_name
        }}</span>
        <span v-if="blok.author_description" class="size-2xs">{{
          blok.author_description
        }}</span>
      </figcaption>
    </figure>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  context: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.facility-review {
  display: grid;
  grid-template-columns: repeat($nb-columns, 1fr);

  @include for-desktop-up {
    grid-template-columns: repeat(11, 1fr);
  }

  figure {
    grid-column: 2 / -2;

    @include for-desktop-up {
      grid-column: 2 / -3;
    }
  }

  .icon {
    margin: 4rem 0 1rem;

    @include for-desktop-up {
      width: 1.875rem;
      height: 1.75rem;
      margin: 0;
      position: absolute;
      top: 0;
      left: 1.875rem;
    }
  }

  .date {
    margin-top: 0.5rem;
    color: var(--text-70);
  }

  .author {
    margin-top: 1rem;
    display: block;

    @include for-desktop-up {
      margin-top: 1.25rem;
    }
  }
}
</style>
